export function covertJobTitle(apiJob) {

    let stringBuilder = []
    stringBuilder.push(apiJob.full_address);
    if (apiJob.key_number) {
        stringBuilder.push(", ")
        stringBuilder.push(apiJob.key_number);
    }
    stringBuilder.push(", ")
    stringBuilder.push(apiJob.agent_name)
    stringBuilder.push(", CheckOut:")
    stringBuilder.push(apiJob.check_out);
    if (apiJob.check_in) {
        stringBuilder.push(", CheckIn:")
        stringBuilder.push(apiJob.check_in);
    }

    return stringBuilder.join("")


}

export function convertDescriptionPrefix(apiJob, lightMessage = false) {
    let pillowCase = 0;
    let bathTower = 0;
    let handTowel = 0;
    let bathMat = 0;

    let qSheet = 0;
    let qDonaCover = 0;
    let kSheet = 0;
    let kDonaCover = 0;
    let sSheet = 0;
    let sDonaCover = 0;

    let stringBuilder = []
    if (apiJob.bedroom != null && apiJob.bedroom > 0) {
        stringBuilder.push("[")
        stringBuilder.push(apiJob.bedroom)
        stringBuilder.push(" Bedroom");
    }
    if (apiJob.bathroom != null && apiJob.bathroom > 0) {
        stringBuilder.push(", ")
        stringBuilder.push(apiJob.bathroom)
        stringBuilder.push(" Bathroom");
        // 1Bathroom = 2 hand Towel+ 1Bath mat
        handTowel = handTowel + apiJob.bathroom * 2;
        bathMat = bathMat + apiJob.bathroom;
    }
    if (apiJob.sofabed != null && apiJob.sofabed > 0) {
        stringBuilder.push(", ")
        stringBuilder.push(" Please bring sofabed linens and put in the wardrobe");
        // 1 Sofa bed = 2pillow case +2 bath Towel+2 Qsheet +1QDona cover
        pillowCase = pillowCase + apiJob.sofabed * 2;
        bathTower = bathTower + apiJob.sofabed * 2;
        qSheet = qSheet + apiJob.sofabed * 2;
        qDonaCover = qDonaCover + apiJob.sofabed;
    }
    if (apiJob.king != null && apiJob.king > 0) {
        // 1K bed = 4pillow case +2 bath Towel+2 Ksheet +1KDona cover 
        stringBuilder.push(", ")
        stringBuilder.push(apiJob.king)
        stringBuilder.push(" King Bed");
        pillowCase = pillowCase + apiJob.king * 4;
        bathTower = bathTower + apiJob.king * 2;
        kSheet = kSheet + apiJob.king * 2;
        kDonaCover = kDonaCover + apiJob.king;
    }
    if (apiJob.queen != null && apiJob.queen > 0) {
        // 1Q bed = 4pillow case +2 bath Towel+2 Qsheet +1QDona cover
        stringBuilder.push(", ")
        stringBuilder.push(apiJob.queen)
        stringBuilder.push(" Queen Bed");
        pillowCase = pillowCase + apiJob.queen * 4;
        bathTower = bathTower + apiJob.queen * 2;
        qSheet = qSheet + apiJob.queen * 2;
        qDonaCover = qDonaCover + apiJob.queen;
    }
    if (apiJob.single != null && apiJob.single > 0) {
        // 1S bed = 4pillow case +1 bath Towel+2 Ssheet +1SDona cover
        stringBuilder.push(", ")
        stringBuilder.push(apiJob.single)
        stringBuilder.push(" Single Bed");
        pillowCase = pillowCase + apiJob.single * 4;
        bathTower = bathTower + apiJob.single * 1;
        sSheet = sSheet + apiJob.single * 2;
        sDonaCover = sDonaCover + apiJob.single;
    }

    stringBuilder.push("]. ");

    let consumableMessage = `${pillowCase} Pillow Case, ${bathTower} Bath Tower, ${handTowel} Hand Tower, ${bathMat} Bath Mat, ${kSheet} K Sheet, ${qSheet} Q Sheet, ${sSheet} S Sheet, ${kDonaCover} K Dona, ${qDonaCover} Q Dona, ${sDonaCover} S Dona `;

    if ('BRING_YOUR_OWN_CONSUMABLE' === (apiJob.consumable_type)) {
        stringBuilder.push("Owner Consumable. ");
    }
    if ('SERVICE_CONSUMABLE' === (apiJob.consumable_type)) {
        if (!lightMessage) {
            stringBuilder.push(consumableMessage);
        }
        stringBuilder.push("Consumables. ");
    }
    if ('NO_CONSUMABLE' === (apiJob.consumable_type)) {
        stringBuilder.push("No Consumable. ");
    }

    // stringBuilder.push(apiJob.description);

    return stringBuilder.join("")
}